import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VLFDatePicker from "@/components/Input/DatePicker";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = [
	"date",
	"fatMassIndex",
	"leanMassIndex",
	"shoulderWidth",
	"chestCircumference",
	"abdomenCircumference",
	"hipCircumference",
	"rightArmCircumference",
	"leftArmCircumference",
	"rightLegCircumference",
	"leftLegCircumference",
];

function HandlePHVInfo(props) {
	const {open, initialData, confirm, close} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData(initialData);
		}
	}, [initialData]);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	return (
		<VLFModal
			maxWidth="md"
			open={open}
			title={initialData ? "Modifica informazione" : "Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, initialData?.id);
				}
			}}
			content={
				<div className="row">
					<div className="col-xs-12 col-sm-6">
						<VLFDatePicker
							label="Data"
							size="small"
							value={formData.date}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, date: value});
							}}
							required
							helperText={errors.indexOf("date") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("date") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="fatMassIndex"
							value={formData.fatMassIndex || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, fatMassIndex: event.target.value});
							}}
							label="Indice massa grassa"
							placeholder="Indice massa grassa"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("fatMassIndex") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("fatMassIndex") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="leanMassIndex"
							value={formData.leanMassIndex || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, leanMassIndex: event.target.value});
							}}
							label="Indice massa magra"
							placeholder="Indice massa magra"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("leanMassIndex") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("leanMassIndex") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="shoulderWidth"
							value={formData.shoulderWidth || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, shoulderWidth: event.target.value});
							}}
							label="Larghezza spalle (cm)"
							placeholder="Larghezza spalle (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("shoulderWidth") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("shoulderWidth") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="chestCircumference"
							value={formData.chestCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									chestCircumference: event.target.value,
								});
							}}
							label="Circonferenza torace (cm)"
							placeholder="Circonferenza torace (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("chestCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("chestCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="abdomenCircumference"
							value={formData.abdomenCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									abdomenCircumference: event.target.value,
								});
							}}
							label="Circonferenza addome (cm)"
							placeholder="Circonferenza addome (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("abdomenCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("abdomenCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="hipCircumference"
							value={formData.hipCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									hipCircumference: event.target.value,
								});
							}}
							label="Circonferenza fianchi (cm)"
							placeholder="Circonferenza fianchi (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("hipCircumference") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("hipCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="rightArmCircumference"
							value={formData.rightArmCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									rightArmCircumference: event.target.value,
								});
							}}
							label="Circonferenza braccio dx (cm)"
							placeholder="Circonferenza braccio dx (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("rightArmCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("rightArmCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="leftArmCircumference"
							value={formData.leftArmCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									leftArmCircumference: event.target.value,
								});
							}}
							label="Circonferenza braccio sx (cm)"
							placeholder="Circonferenza braccio sx (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("leftArmCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("leftArmCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="rightLegCircumference"
							value={formData.rightLegCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									rightLegCircumference: event.target.value,
								});
							}}
							label="Circonferenza gamba dx (cm)"
							placeholder="Circonferenza gamba dx (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("rightLegCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("rightLegCircumference") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-6">
						<VLFTextField
							name="leftLegCircumference"
							value={formData.leftLegCircumference || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({
									...formData,
									leftLegCircumference: event.target.value,
								});
							}}
							label="Circonferenza gamba sx (cm)"
							placeholder="Circonferenza gamba sx (cm)"
							size="small"
							type="number"
							required
							helperText={
								errors.indexOf("leftLegCircumference") !== -1
									? REQUIRED_FIELD
									: ""
							}
							error={errors.indexOf("leftLegCircumference") !== -1}
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandlePHVInfo;
